const editService = {
  pageTitle: 'Editar servicio',
  buttonReport: 'Informes',
  reportMenuItem: 'Generar informe (.pdf)',
  exportMenuItem: 'Exportar dados (.xls)',
  serviceDetailsTitle: 'Detalles del servicio',
  serviceDate: 'Fecha del servicio',
  serviceAccountable: 'Creado por:',
  doneInDelay: 'Completado con retraso:',
  endOfMonthExpiration: 'Expira a fin de mes:',
  mandatoryActions: 'Las acciones son obligatorias:',
  localization: 'Localización',
  noCoordinates: 'Coordenadas no proporcionadas',
  yes: 'Sí',
  no: 'No',
  discard: 'Descartar',
  confirm: 'Confirmar',
  goToPlace: 'Ir a la página del lugar',
  goToEquipment: 'Ir a detalles del equipo',
  actionsMandatory: 'Al completar el servicio, las acciones eran obligatorias para las preguntas con respuesta "No conforme"',
  actionsNumber: 'Acciones abiertas para este servicio:',
  actionCompleted: 'finalizada',
  actionsCompleted: 'finalizadas',
  expiration: 'Fecha de caducidad:',
  daysRemaining: 'días restantes',
  daysOverdue: 'días de atraso',
  dayRemaining: 'día restantes',
  dayOverdue: 'día de atraso',
  createdAt: 'Creado en:',
  downloadFiles: 'Descargar archivos (.zip)',
  web: "Web",
  app: "App",
  legacy: "Legado",
  legacyApp: "App Legado",
  legacyWeb: "Web Legado",
  appQrcode: "App Código QR",
  appCalendar: "App Calendario",
  appPlaces: "App Lugares",
  appAllEquipments: "App Lista de Equipos",
  appMap: "App Mapa",
  source: "Fuente:",
};

export default editService;